<template>
  <a-spin tip="Your document is being processed, do not leave this page!" :spinning="pageLoading">
    <div class="wrapper">
      <div class="wrapper-header">
        <span>
          <a-icon type="wallet" class="margin-right-small" />
          Tax Transaction Verification List
        </span>
        <a-button @click="handleReload" size="small" icon="reload"></a-button>
      </div>
      <div class="wrapper-body">
        <a-card>
          <div style="display: none">
            <a-select placeholder="Ex: Need Process ... " v-model="tabs.active" :disabled="true" @change="moreSearch"
              class="width-full" initialValue="process" allowClear>
              <a-select-option value="needprocess">Need Process</a-select-option>
              <a-select-option value="verified">Transaction Verified</a-select-option>
            </a-select>
          </div>
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
              <a-input-search v-model="search" placeholder="Quick Search" />
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
              <div style="width:100%;text-align:left">
                <a-badge :dot="showbadge">
                  <a-button :class="getScreen ? 'margin-top' : ''"
                    :icon="advancedsearch == 'display:none' ? 'down' : 'up'" @click="handleshowMore">{{
                      advancedsearch == "display:none" ? "More" : "Less"
                    }}</a-button>
                </a-badge>
                <!-- &nbsp;
                <a-button
                  type="primary"
                  icon="plus"
                  @click="handleShowModalProcess"
                  :loading="loading.create"
                >
                  Tax Manual
                </a-button> -->
              </div>
            </a-col>
          </a-row>
          <a-row :style="advancedsearch" :gutter="16" class="margin-top">
            <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
              <div class="m-form-item-wrapper">
                <label>Type</label>
                <a-select placeholder="Ex: All Type ... " v-model="typetransaction" class="width-full" initialValue="all">
                  <a-select-option value="all">All Type</a-select-option>
                  <a-select-option v-for="item in type_trans_master" :key="item.value" :value="item.value">
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
              <div class="m-form-item-wrapper">
                <label>Create Date</label>
                <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="taxDt" :format="getDefaultDateFormat"
                  allowClear />
              </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
              <!-- <div class="m-form-item-wrapper">
                <label>Tax Type</label>
                <a-select
                  placeholder="Ex: All Type ... "
                  v-model="typetransaction"
                  class="width-full"
                  initialValue="all"
                >
                  <a-select-option value="all">All Type</a-select-option>
                  <a-select-option
                    v-for="item in type_tax_master"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </div> -->
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
              <!-- <div class="m-form-item-wrapper">
                <label>Status Document</label>
                <a-select
                  showSearch
                  v-model="stsDocument"
                  placeholder="Select Status Document"
                  class="width-full"
                  initialValue="all"
                  allowClear
                  :filterOption="filterOption"
                >
                  <a-select-option value="all"
                    >All Status Document</a-select-option
                  >
                  <a-select-option value="yes"
                    >Document is Uploaded</a-select-option
                  >
                  <a-select-option value="no"
                    >Document isn't Uploaded</a-select-option
                  >
                </a-select>
              </div> -->
            </a-col>
          </a-row>
        </a-card>
        <div class="bordered">
          <a-tabs class="custom-tabs" :activeKey="tabs.active" @change="handleTab">
            <a-tab-pane key="needprocess">
              <template slot="tab">
                <span>Need Process</span>&nbsp;
                <a-badge class="m-badge m-badge-small" :count="needProcess.length"
                  :numberStyle="{ backgroundColor: 'red' }" v-if="needProcess.length > 0">
                </a-badge>
              </template>
              <a-table :rowKey="(record, index) => {
                return index.toString();
              }
                " size="small" bordered :scroll="{ x: 950 }" :columns="columns.needProcess" :dataSource="needProcess"
                :loading="tabs.loading" :pagination="pagination">
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{
                    (pagination.page - 1) * pagination.pageSize + index + 1
                  }}</span>
                </template>
                <template slot="tlc" slot-scope="data">
                  <div style="width:100%;text-align:center">
                    <span>{{
                      data.create_dt
                      ? moment(data.create_dt).format(getDefaultDateFormat)
                      : "-"
                    }} | {{ data.tlc }}</span>
                  </div>
                </template>
                <template slot="trans_dt" slot-scope="text, data">
                  <span>{{
                    data.trans_dt
                    ? moment(data.trans_dt).format(getDefaultDateFormat)
                    : "-"
                  }}</span>
                </template>
                <template slot="no_trans" slot-scope="text, data">
                  <a @click="handlelinkNo(data)">{{ data.no_transaction }}</a>
                </template>
                <template slot="value" slot-scope="data">
                  <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.value" />
                </template>
                <template slot="aksi1" slot-scope="text, data">
                  <a-button @click="handleShowModalProcess(data, 'new')" icon="edit" type="primary" :loading="loading.modalProcess &&
                    loading.modalProcessKey == data.id_transaksi
                    ">Process</a-button>
                  <!-- &nbsp;
                  <a-button
                    v-if="data.type == 'tax_manual'"
                    :loading="
                      loading.deletetaxmanual &&
                        loading.modalDepositKey == data.id_transaction
                    "
                    @click="handleDeleteModalDeposit(data)"
                    icon="delete"
                    type="danger"
                  ></a-button> -->
                </template>
              </a-table>
            </a-tab-pane>
            <!-- <a-tab-pane v-if="!isAkuntansi" key="queue">
              <template slot="tab">
                <span>Credit Tax List </span>&nbsp;
                <a-badge
                  class="m-badge m-badge-small"
                  :count="queue.length"
                  :numberStyle="{ backgroundColor: 'red' }"
                  v-if="queue.length > 0"
                >
                </a-badge>
              </template>
              <a-table
                :rowKey="(record, index) => {return index.toString();}"
                size="small"
                bordered
                :scroll="{ x: 1300 }"
                :columns="columns.queue"
                :dataSource="queue"
                :loading="tabs.loading"
              >
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{ index + 1 }}</span>
                </template>
                <template slot="createBy" slot-scope="text, data">
                  <h4 class="margin-remove">{{ data.tlc_create }}</h4>
                  <span>{{
                    moment(data.create_dt).format(getDefaultDateFormat)
                  }}</span>
                </template>
                <template slot="duedate" slot-scope="text, data">
                  <span>{{
                    moment(data.due_date).format(getDefaultDateFormat)
                  }}</span>
                </template>
                <template slot="value" slot-scope="text, data">
                  <span>{{ formatCurrency(data.mata_uang, data.value) }}</span>
                </template>
                <template slot="sts" slot-scope="text, data">
                  <Status 
                  v-if="data.status!=null"
                  :status="data.status" />
                  <span v-else>-</span>
                </template>
                <template slot="aksi" slot-scope="text, data">
                  <a-button-group>
                    <a-button
                      @click="handleManifestQueue(data)"
                      icon="file"
                    ></a-button>
                    <a-button type="primary" @click="handleRelease(data)"
                    :disabled="!(data.status=='Verified' || data.status==null)"
                      >Release</a-button
                    >
                  </a-button-group>
                </template>
              </a-table>
            </a-tab-pane>-->
            <a-tab-pane tab="Transaction Verified" key="verified">
              <a-table :rowKey="(record, index) => { return index.toString(); }" size="small" bordered
                :scroll="{ x: 1030 }" :columns="columns.verified" :dataSource="verified" :loading="tabs.loading">
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{
                    (pagination.page - 1) * pagination.pageSize + index + 1
                  }}</span>
                </template>
                <template slot="tlc" slot-scope="data">
                  <div style="width:100%;text-align:center">
                    <span>{{
                      data.create_dt
                      ? moment(data.create_dt).format(getDefaultDateFormat)
                      : "-"
                    }} | {{ data.tlc }}</span>
                  </div>
                </template>
                <template slot="trans_dt" slot-scope="text, data">
                  <span>{{
                    data.trans_dt
                    ? moment(data.trans_dt).format(getDefaultDateFormat)
                    : "-"
                  }}</span>
                </template>
                <template slot="no_trans" slot-scope="text, data">
                  <a @click="handlelinkNo(data)">{{ data.no_transaction }}</a>
                </template>
                <template slot="value" slot-scope="data">
                  <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.value" />
                </template>
                <template slot="status" slot-scope="data">
                  <Status :status="data.status" />
                </template>
                <template slot="aksi" slot-scope="data">
                  <a-button-group>
                    <a-tooltip class="m-tooltip-inner" placement="bottomLeft" title="View Transaction">
                      <a-button @click="handleShowModalProcess(data, 'view')" icon="eye"
                        :disabled="data.status != 'Verified'" :loading="loading.modalProcess &&
                          loading.modalProcessKey == data.id_transaksi && loading.loadJenis == 'view'
                          "></a-button>
                    </a-tooltip>
                    <a-tooltip class="m-tooltip-inner" placement="bottomLeft" title="Edit">
                      <a-button @click="handleShowModalProcess(data, 'edit')" icon="edit" type="danger"
                        :disabled="data.status == 'Verified'" :loading="loading.modalProcess &&
                          loading.modalProcessKey == data.id_transaksi && loading.loadJenis == 'edit'
                          "></a-button>
                    </a-tooltip>
                  </a-button-group>
                </template>
              </a-table>
            </a-tab-pane>
            <!-- <a-tab-pane tab="SPT Done List" key="done">
              <a-table
                :rowKey="(record, index) => {return index.toString();}"
                size="small"
                bordered
                :scroll="{ x: 1300 }"
                :columns="columns.release"
                :dataSource="release"
                :loading="tabs.loading"
              >
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{ index + 1 }}</span>
                </template>
                <template slot="createBy" slot-scope="text, data">
                  <h4 class="margin-remove">{{ data.tlc_create }}</h4>
                  <span>{{
                    moment(data.create_dt).format(getDefaultDateFormat)
                  }}</span>
                </template>
                <template slot="duedate" slot-scope="text, data">
                  <span>{{
                    moment(data.due_date).format(getDefaultDateFormat)
                  }}</span>
                </template>
                <template slot="value" slot-scope="text, data">
                  <span>{{ formatCurrency(data.mata_uang, data.value) }}</span>
                </template>
                <template slot="aksi" slot-scope="text, data">
                  <a-button-group>
                    <a-button @click="handleManifest(data)" icon="file"
                      >Manifest</a-button
                    >
                    <a-button
                      :disabled="data.flag == null"
                      @click="handleDocument(data)"
                      icon="eye"
                      type="primary"
                    ></a-button>
                  </a-button-group>
                </template>
              </a-table>
            </a-tab-pane> -->
          </a-tabs>
        </div>
      </div>

      <TaxDepositEntry :v-if="modalDepositEntry" :visibleTaxModal="modalDepositEntry" :getType_tax="type_tax_master"
        :getListsetoranpajak="dataEdit.listsetoranpajak" :getListobjekpajak="dataEdit.listobjekpajak"
        :tax_type="dataEdit.tax_type" :file_document_tax="dataEdit.document_tax"
        :kode_setoran_pajak="dataEdit.kode_setoran_pajak" :objek_pajak="dataEdit.kode_objek_pajak"
        :id_header="dataEdit.id_transaction" :id_dtl="dataEdit.id_dtl_transaction" :dpp_value="dataEdit.value_dpp"
        :value="dataEdit.value" :file="dataEdit.fileList" :jenis_transaksi="dataEdit.type" />

      <a-modal v-model="modalProcess" v-if="modalProcess" @ok="handleModalProcess" @cancel="handleModalClose"
        :maskClosable="false" :width="'90%'">
        <span slot="title"> <a-icon type="reconciliation" />&nbsp;Verification Transaction Tax {{
          modalData.jenis_transaksi_label.toUpperCase() }} # {{ modalData.no_transaction }} </span>
        <a-row :gutter="16">
          <a-col :xs="{ span: 24 }" :lg="{ span: expand.leftcolumn }">
            <a-spin :spinning="loading.spinform" tip="Loading ...  ">
              <div class="container-dash">
                <a-form :form="formmodal">
                  <div style="display:none">
                    <a-form-item label="Transaction Type">
                      <a-input disabled
                        v-decorator="['transaction_type',
                          { rules: [{ required: false }], initialValue: modalData.jenis_transaksi_label.toUpperCase() }]"
                        class="lblTransactionType">
                      </a-input>
                    </a-form-item>
                    <a-form-item label="No Transaction">
                      <a-input disabled v-decorator="['no_transaction',
                        { rules: [{ required: false }], initialValue: modalData.no_transaction }]">
                      </a-input>
                    </a-form-item>
                  </div>
                  <div class="container-essential">
                    <a-row :gutter="12">
                      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                        <a-form-item label="Detil transaction">
                          <!-- modalData.id_tax_verif_trans != '' -->
                          <a-select showSearch v-decorator="[
                            'id_dtl',
                            {
                              rules: [{ required: true }], initialValue: modalData.id_dtl
                            },
                          ]" :disabled="true" class="select-between" @change="handle_DetilTransaction" ref="refid_dtl"
                            optionFilterProp="children" :filterOption="filterOptiondtl">
                            <a-select-option v-for="item in modalData.detil_transaction" :key="item.id_dtl"
                              :disabled="item.disabled">
                              <div style="display: flex;justify-content: space-between;opacity: 1;width: 100%;">
                                <span>[{{ moment(item.tanggal, getStandartFormatDate).format(getDefaultDateFormat) }}] {{
                                  item.detail }}</span>
                                <span style="float: right;"><b>{{
                                  formatCurrency(
                                    item.currency,
                                    parseFloat(item.kredit)
                                  )
                                }}</b></span>
                              </div>
                            </a-select-option>
                          </a-select>
                          <div v-if="modalData.potensial_tax" class="m-form-description-small">
                            <div style="width:100%;">
                              <span>
                                {{ modalData.dtl_value }}
                              </span><br />
                              <div v-if="modalData.potensial_tax == '1'" class="lbltaxable">
                                {{ 'POTENTIALLY TAXABLE' }}</div>
                              <div v-else class="lblnottaxable">
                                {{ "IS'NT POTENTIALLY TAXABLE" }}
                              </div>
                            </div>
                          </div>
                          <!-- <div
                          v-if="modalData.potensial_tax"
                          class="m-form-description-small"
                        >
                          <div 
                            style="width:100%;"
                          >
                              <span v-if="modalData.potensial_tax == '1'" class="lbltaxable">
                                    {{ 'POTENTIALLY TAXABLE' }}</span>
                                  <span v-else class="lblnottaxable">
                                    {{ "IS'NT POTENTIALLY TAXABLE" }}
                                  </span>
                            </div>
                        </div> -->

                        </a-form-item>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                        <a-form-item label="Verificator Note">
                          <a-textarea disabled :rows="4" v-model="modalData.reason_potensial" />
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </div>
                  <div class="container-dash" style="margin-top:12px;margin-bottom:12px">
                    <a-row :gutter="8">
                      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                        <a-form-item label="Value After Tax">
                          <a-radio-group button-style="solid" v-decorator="['is_vat', { rules: [{ required: true }] }]"
                            @change="handleChangeVat" ref="ref_is_vat" :disabled="modalData.anggaran.loadingtree">
                            <a-radio-button value="1">Yes</a-radio-button>
                            <a-radio-button value="0">No</a-radio-button>
                          </a-radio-group>
                        </a-form-item>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                        <a-form-item label="Cost Center">
                          <a-select
                            :disabled="modalData.costcenter.length == 0 || isvat || modalData.anggaran.loadingtree"
                            showSearch v-decorator="[
                              'cost_center',
                              {
                                rules: [{ required: !isvat }],
                                initialValue: dataEdit.cost_center,
                              },
                            ]" placeholder="Please Select Cost Center" @change="handleCost">
                            <a-select-option v-for="item in modalData.costcenter" :key="item.value">{{ item.text }}
                              ({{
                                item.nama_pekerjaan ? item.nama_pekerjaan : "-"
                              }})</a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                        <a-form-item label="Allotment">
                          <a-select
                            :disabled="modalData.peruntukan.length == 0 || isvat || modalData.anggaran.loadingtree"
                            showSearch v-decorator="[
                              'peruntukan',
                              {
                                rules: [{ required: !isvat }],
                                initialValue: dataEdit.peruntukan,
                              },
                            ]" placeholder="Please Select Allotment" @change="handle_Peruntukan" ref="refperuntukan"
                            optionFilterProp="children" :filterOption="filterOption">
                            <a-select-option v-for="item in modalData.peruntukan" :key="item.value">
                              {{ item.text }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                      <a-col :xs="{ span: 24 }" :lg="{ span: 6 }">
                        <a-form-item label="Budget Code">
                          <a-tree-select v-decorator="[
                            'kode_anggaran',
                            {
                              rules: [{ required: !isvat }],
                              initialValue: modalData.treekode_anggaran,
                            },
                          ]" show-search style="width: 100%" @select="handlechoiceCost"
                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                            :tree-data="modalData.anggaran.tree" treeNodeFilterProp="children"
                            :filterTreeNode="filterTreeNode" placeholder="Please Select Budget Code"
                            :treeExpandedKeys="modalData.treeExpandedKeys" allow-clear :disabled="modalData.anggaran.loadingtree ||
                              modalData.anggaran.tree == undefined ||
                              modalData.anggaran.tree.length == 0 || isvat
                              " tree-default-expand-all>
                            <span slot="title" slot-scope="item">
                              <table style="width:100%">
                                <tr>
                                  <td>
                                    <span>{{ item.texttitle }} -
                                      {{ item.kode_anggaran }}</span>
                                  </td>
                                  <td>
                                    <span style="float:right"><b>{{
                                      formatRupiah(parseFloat(item.rekap))
                                    }}</b></span>
                                  </td>
                                </tr>
                              </table>
                            </span>
                            <template slot="suffixIcon"><a-icon :type="modalData.anggaran.loadingtree ? 'loading' : 'down'
                                " />
                            </template>
                          </a-tree-select>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </div>
                  <a-row :gutter="8">
                    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                      <div class="container-dash">
                        <a-row :gutter="8">
                          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                            <a-form-item label="Tax Type">
                              <a-select v-decorator="[
                                'tax_type',
                                {
                                  rules: [{ required: true }],
                                  initialValue: modalData.type_pajak,
                                },
                              ]" show-search optionFilterProp="children" :filterOption="filterOption"
                                @change="handleChangeTaxType">
                                <a-select-option v-for="item in listtax" :key="item.value" :value="item.value">
                                  {{ item.text }}
                                </a-select-option>
                              </a-select>
                            </a-form-item>
                            <a-form-item label="Tax Deposit">
                              <a-select v-decorator="[
                                'kode_setoran_pajak',
                                {
                                  rules: [{ required: true }],
                                  initialValue: modalData.tax_deposit,
                                },
                              ]" option-filter-prop="children" :filter-option="filterOption" showSearch>
                                <a-select-option v-for="item in modalData.listsetoranpajak" :key="item.value"
                                  :value="item.value" :text="item.text">
                                  {{ item.text }}
                                </a-select-option>
                              </a-select>
                            </a-form-item>
                            <a-form-item label="Tax Object" v-if="!(
                              modalData.reftax_type == 'pph_21' ||
                              modalData.reftax_type == 'ppn'
                            )
                              ">
                              <a-select v-decorator="[
                                'objek_pajak',
                                {
                                  rules: [{ required: false }],
                                  initialValue: modalData.tax_object,
                                },
                              ]" option-filter-prop="children" :filter-option="filterOption" showSearch allowClear>
                                <a-select-option v-for="item in modalData.listobjekpajak" :key="item.value"
                                  :value="item.value" :text="item.text">
                                  {{ item.text }}
                                </a-select-option>
                              </a-select>
                            </a-form-item>
                          </a-col>
                          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                            <a-form-item label="DPP Value">
                              <a-input-number class="m-width-full m-text-align-right"
                                v-on:keydown.enter.prevent="preventEnterButton"
                                :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="['dpp_value',
                                  {
                                    rules: [{ required: true, validator: checkPrice }],
                                    initialValue: modalData.dpp_value,
                                  },
                                ]" />
                            </a-form-item>
                            <a-form-item label="Tax Value">
                              <a-input-number class="m-width-full m-text-align-right"
                                v-on:keydown.enter.prevent="preventEnterButton"
                                :formatter="(value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                                :parser="(value) => value.replace(/\\s?|(,*)/g, '')" v-decorator="[
                                  'tax_value',
                                  {
                                    rules: [{ required: true, validator: checkPrice }],
                                    initialValue: modalData.tax_value,
                                  },
                                ]" />
                            </a-form-item>
                            <a-form-item label="File Document Tax">
                              <a-upload :fileList="modalData.fileList" v-decorator="[
                                'file_document_tax',
                                {
                                  rules: [
                                    { required: false, validator: doc_validation },
                                  ],
                                },
                              ]" :remove="handleRemoveAttachment" :beforeUpload="beforeUploadAttachment">
                                <a-button> <a-icon type="upload" />Select File </a-button>
                              </a-upload>
                            </a-form-item>
                          </a-col>
                        </a-row>
                        <a-button v-if="modalData.submited == '0'" type="primary" icon="disk"
                          @click="handleAddVarification" ref="addMainBtn" :loading="loading.addVarification"
                          :disabled="modalData.anggaran.loadingtree" class="m-width-full margin-top">
                          Add
                        </a-button>
                        <a-row :gutter="8" v-else>
                          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                            <a-button type="primary" @click="handleAddVarification" ref="addMainBtn"
                              :loading="loading.addVarification" class="m-width-full margin-top"
                              :disabled="modalData.anggaran.loadingtree">
                              Change
                            </a-button>
                          </a-col>
                          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                            <a-button type="danger" @click="handleCancelVarification" ref="addMainBtn"
                              class="m-width-full margin-top" :disabled="modalData.anggaran.loadingtree">
                              Cancel
                            </a-button>
                          </a-col>
                        </a-row>
                      </div>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                      <a-config-provider :locale="getLocalConfigProvider()">
                        <a-table bordered size="small" id="tbl_data_dtl" :rowKey="(record, index) => { return index; }"
                          :columns="columns.editing_verif_dtl" :dataSource="data_verif_dtl"
                          :pagination="paginationverificationdtl" :scroll="{ x: 835 }"
                          :rowClassName="(record, index) => { return record.id == modalData.id_tax_verif_trans ? 'selectedRow' : '' }">
                          <template slot="title">
                            List Details
                          </template>
                          <template slot="nomor" slot-scope="text, data,index">
                            <div class="m-text-align right">{{ index + 1 }}</div>
                          </template>
                          <template slot="nover" slot-scope="data">
                            {{ data.no_trans }}
                          </template>
                          <template slot="typetax" slot-scope="data">
                            <div class="m-text-align left">{{ gettitletax(data.tax_type) }}</div>
                          </template>
                          <template slot="dppvalue" slot-scope="data">
                            <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.dpp_value" />
                          </template>
                          <template slot="value" slot-scope="data">
                            <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.tax_value" />
                          </template>
                          <template slot="action" slot-scope="text,data,index">
                            <a-button-group>
                              <a-button type="primary" @click="editdtl(data.id)" icon="edit" size="small"
                                :disabled="modalData.submited == '1'">
                              </a-button>
                              <a-button type="danger" @click="deletedtl(data.id)" icon="close" size="small"
                                :disabled="modalData.submited == '1'">
                              </a-button>
                            </a-button-group>
                          </template>
                        </a-table>
                      </a-config-provider>
                    </a-col>
                  </a-row>
                </a-form>
              </div>
            </a-spin>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: expand.rightcolumn }">
            <div class="container-headertable">
              <div class="m-display-flex space-between align-middle">
                <span>List Details</span>
                <!-- <a-button 
                      v-if="loading.loadJenis != 'view'"
                      @click="handleExpand()"
                      size="small"
                    >
                        <span>{{ expand.labelExpand }}</span>
                    </a-button> -->
              </div>
            </div>
            <a-config-provider :locale="getLocalConfigProvider()">
              <a-table bordered size="small" id="tbl_dtl" :rowKey="(record, index) => { return index; }"
                :columns="columns.verificationdtl" :dataSource="verificationdtl_source"
                :pagination="paginationverificationdtl" :scroll="{ x: 835 }">
                <template slot="title">
                  <a-input-search v-decorator="['searchListDtl', { rules: [{ required: false }] }]"
                    @change="searchingListDtl" placeholder="Quick Search" />
                </template>
                <template slot="nomor" slot-scope="text, data,index">
                  <div class="m-text-align right">{{ index + 1 }}</div>
                </template>
                <template slot="detail" slot-scope="data">
                  <div class="m-text-align left">{{ data.detail }}</div>
                  <small v-if="data.kode_anggaran"><i>[{{ data.kode_anggaran + "-" + data.item_anggaran }}]</i></small>
                </template>
                <template slot="notrans" slot-scope="data">
                  <div class="m-text-align center">{{ data.no_trans }}</div>
                </template>
                <template slot="dttrans" slot-scope="data">
                  <div class="m-text-align center">{{ moment(data.tgl, getStandartFormatDate).format(getDefaultDateFormat)
                  }}</div>
                </template>
                <template slot="price" slot-scope="data">
                  <div class="m-text-align center">{{ formatCurrency('IDR', data.harga) }}</div>
                </template>
                <template slot="pttax" slot-scope="data">
                  <div class="m-text-align center">{{ data.potensial_tax && data.potensial_tax == "1" ? "Yes" : "No" }}
                  </div>
                </template>
                <template slot="type" slot-scope="data">
                  <div class="m-text-align left">{{ gettitletax(data.tax_type) }}</div>
                </template>
                <template slot="dppvalue" slot-scope="data">
                  <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.dpp_value" />
                </template>
                <template slot="value" slot-scope="data">
                  <CurrencyJustified :currencyValue="'IDR'" :valueNumber="data.tax_value" />
                </template>
                <template slot="action" slot-scope="text,data,index">
                  <div :class="loading.loadJenis == 'view' ? 'm-text-align center' : 'm-text-align right'">
                    <a-button-group>
                      <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="View File">
                        <a-button
                          :disabled="data.tax_document_name == '' || data.tax_document_name == null || loading.spinform"
                          type="default" @click="viewFiledtl(data.tax_document_name, data.tax_document_path)" icon="file"
                          size="small">
                        </a-button>
                      </a-tooltip>
                      <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="Edit Row">
                        <a-button v-if="loading.loadJenis != 'view'" type="primary" @click="editdtl(data.id)" icon="edit"
                          size="small" :loading="loading.spinform && data.id == modalData.id_tax_verif_trans"
                          :disabled="loading.spinform || modalData.id_tax_verif_trans != ''">
                        </a-button>
                      </a-tooltip>
                      <!-- <a-tooltip class="m-tooltip-inner" placement="bottomRight" title="Delete Row">
                    <a-popconfirm placement="topRight" okText="Yes" cancelText="No" @confirm="deletedtl(data.id)">
                      <template slot="title">
                        <p>Are you sure delete this data?</p>
                      </template>
                      <a-button
                        v-if="loading.loadJenis != 'view'"
                        type="danger"
                        icon="close"
                        size="small"
                        :disabled="loading.spinform || modalData.id_tax_verif_trans!=''"
                        :loading="
                          loading.deleteVarification &&
                            loading.modalProcessKey == data.id
                        "
                      >
                      </a-button>
                    </a-popconfirm>
                  </a-tooltip> -->
                    </a-button-group>
                  </div>
                </template>
                <!-- <template slot="footer">
                <a-row :gutter="16">
                  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                    <a-statistic
                      title="Total Deduction"
                      :value="formatCurrency('IDR', totalVerificationdtl)"
                      class="m-text-align left"
                    />
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                    <a-statistic
                      title="Real Value AR"
                      :value="formatCurrency('IDR', realAR ? realAR : 0)"
                      class="m-text-align left"
                    />
                  </a-col>
                </a-row>
              </template> -->
              </a-table>
            </a-config-provider>
          </a-col>
        </a-row>
        <!-- v-if="loading.loadJenis != 'view'" -->
        <div slot="footer">
          <a-button @click="submitverified" type="primary"
            v-if="!(emptydataverified || modalData.id_tax_verif_trans != '' || data_verif_dtl.length > 0) && loading.loadJenis != 'view'"
            :loading="loading.submitVarification">Set Verified Transaction</a-button>
          <a-button @click="returntoList" type="danger"
            v-if="(emptydataverified || modalData.id_tax_verif_trans != '' || data_verif_dtl.length > 0) && loading.loadJenis != 'view'"
            :disabled="modalData.anggaran.loadingtree">
            Return to List Details</a-button>
        </div>
      </a-modal>
    </div>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import shortingArray from "@/mixins/MultishortArray";
import GlobalMethod from "@/mixins/GlobalMethod";
import CheckboxAll from "@/components/CheckboxAllHeader.vue";
import TaxDepositEntry from "@/components/TaxDepositEntry.vue";
import _ from "lodash";

export default {
  name: "list-tax-verification",
  mixins: [CurrencyFormat, HandleRoute, shortingArray, GlobalMethod],
  components: { CheckboxAll, TaxDepositEntry },
  data() {
    const columns = {
      verified: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 50,
          align: "center",
        },
        {
          title: "No",
          key: "no",
          scopedSlots: { customRender: "no_trans" },
          width: 210,
        },
        {
          title: "Description",
          key: "description",
          dataIndex: "description",
          width: 200,
        },
        {
          title: "Type",
          key: "type",
          dataIndex: "jenis_transaksi_label",
          width: 125,
        },
        {
          title: "Create Date | TLC",
          key: "tlc",
          scopedSlots: { customRender: "tlc" },
          width: 100,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 145,
        },
        {
          title: "Status",
          key: "status",
          scopedSlots: { customRender: "status" },
          fixed: "right",
          width: 120,
          align: "center",
        },
        {
          title: "Action",
          key: "action",
          width: 100,
          scopedSlots: { customRender: "aksi" },
          fixed: "right",
          align: "center",
        },
      ],
      queue: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 40,
          align: "center",
        },
        {
          title: "No",
          key: "no",
          dataIndex: "no_transaksi",
          width: 230,
        },
        {
          title: "Deskripsi",
          key: "deskripsi",
          dataIndex: "catatan",
          width: 250,
        },
        {
          title: "Supplier",
          key: "supplier",
          width: 200,
          dataIndex: "nama_supplier",
        },
        {
          title: "No Invoice",
          key: "no_invoice",
          width: 150,
          dataIndex: "no_invoice",
        },
        {
          title: "Create By",
          key: "create_by",
          scopedSlots: { customRender: "createBy" },
          width: 150,
        },
        {
          title: "Due Date",
          key: "due_date",
          scopedSlots: { customRender: "duedate" },
          width: 150,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
          align: "right",
        },
        {
          title: "Status",
          key: "sts",
          scopedSlots: { customRender: "sts" },
          width: 120,
          align: "center",
          fixed: "right",
        },
        {
          title: "Release",
          key: "release",
          width: 140,
          scopedSlots: { customRender: "aksi" },
          align: "center",
          fixed: "right",
        },
      ],
      needProcess: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 50,
          align: "center",
        },
        {
          title: "No",
          key: "no",
          scopedSlots: { customRender: "no_trans" },
          width: 210,
        },
        {
          title: "Description",
          key: "description",
          dataIndex: "description",
          width: 200,
        },
        {
          title: "Type",
          key: "type",
          dataIndex: "jenis_transaksi_label",
          width: 125,
        },
        {
          title: "Create Date | TLC",
          key: "tlc",
          scopedSlots: { customRender: "tlc" },
          width: 100,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 145,
        },
        {
          title: "Action",
          fixed: "right",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "aksi1" },
        },
      ],
      verificationdtl: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        {
          title: "Transaction Date",
          key: "dttrans",
          scopedSlots: { customRender: "dttrans" },
          width: 150,
        },
        {
          title: "Detil transaction",
          key: "detail",
          scopedSlots: { customRender: "detail" },
          width: 230,
        },
        {
          title: "Price",
          key: "price",
          scopedSlots: { customRender: "price" },
          width: 150,
        },
        {
          title: "Potential Tax",
          key: "pttax",
          scopedSlots: { customRender: "pttax" },
          width: 150,
        },
        {
          title: "No.Verification",
          key: "notrans",
          scopedSlots: { customRender: "notrans" },
          width: 150,
        },
        {
          title: "Type tax",
          key: "type",
          scopedSlots: { customRender: "type" },
          width: 150,
        },
        {
          title: "DPP Value",
          key: "dppvalue",
          scopedSlots: { customRender: "dppvalue" },
          width: 150,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
        },
        {
          title: "Action",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 85,
        },
      ],
      editing_verif_dtl: [
        {
          title: "#",
          key: "nomor",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        {
          title: "No.Verification",
          key: "nover",
          scopedSlots: { customRender: "nover" },
          width: 150,
        },
        {
          title: "Type Tax",
          key: "typetax",
          scopedSlots: { customRender: "typetax" },
          width: 150,
        },
        {
          title: "DPP Value",
          key: "dppvalue",
          scopedSlots: { customRender: "dppvalue" },
          width: 150,
        },
        {
          title: "Value",
          key: "value",
          scopedSlots: { customRender: "value" },
          width: 150,
        },
        {
          title: "Action",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 85,
        },
      ]
    };
    let doc_validation = (rule, value, callback) => {
      if (this.modalData.fileList && this.modalData.fileList == null) {
        callback(new Error("Please Complete Your Form Input!"));
      } else {
        callback();
      }
    };
    let type_tax_master = [
      { value: 'fee_lain_lain', text: 'Fee Lain-lain' },
      { value: 'pph_22_15', text: 'PPH 22-15 %' },
      { value: 'pph_23', text: 'PPH 23' },
      { value: 'ppn_dipungut', text: 'PPN Dipungut' },
      { value: 'ppn_memungut', text: 'PPN Memungut' },
      { value: 'ppn_migas', text: 'PPN MIGAS' },
      { value: 'ppn_sktd', text: 'PPN SKTD' },
      { value: 'ppn', text: 'PPN' },
    ];
    let type_trans_master = [
      { value: 'lap_bailout', text: 'BAILOUT FUND REPORT' },
      { value: 'klaim_pd', text: 'KLAIM PD' },
      { value: 'klaim_pp', text: 'KLAIM PP' },
      { value: 'klaim_direktur', text: 'KLAIM DIREKTUR' },
      { value: 'klaim_cc', text: 'KLAIM CC Direktur' },
      { value: 'klaim_cc_pd', text: 'KLAIM CC PD' },
      { value: 'klaim_cc_pp', text: 'KLAIM CC PP' },
      { value: 'kas_kecil', text: 'KAS KECIL' },
      { value: 'lk_um_pp', text: 'LAP UM PP' },
      { value: 'lk_um_pd', text: 'LAP UM PD' },
      { value: 'other_income', text: 'OTHER INCOME' },
      { value: 'other_outcome', text: 'OTHER OUTCOME' },
    ];
    return {
      type_trans_master,
      type_tax_master,
      doc_validation,
      columns,
      pageLoading: false,
      loading: {
        modalProcessKey: "",
        modalProcess: false,
        create: false,
        addVarification: false,
        deletetaxmanual: false,
        editVarification: false,
        deleteVarification: false,
        spinform: false,
        loadJenis: ""
      },
      tabs: {
        active: "needprocess",
        loading: false,
      },
      verified: [],
      needProcess: [],
      queue: [],
      verified_origin: [],
      needProcess_origin: [],
      queue_origin: [],
      search: undefined,
      typetransaction: "all",
      transactionDt: [],
      taxDt: [],
      buktiTransfer: [],
      modalDepositEntry: false,
      advancedsearch: "display:none",
      needProcessSuplier: [],
      quequeSuplier: [],
      releaseSuplier: [],
      listSuplier: [],
      stsDocument: "all",
      revisedStatus: "all",
      dataEdit: [],
      modalProcess: false,
      modalData: {
        id_tax_verif_trans: "",
        costcenter: [],
        costcenterOri: [],
        jenis_anggaran: [],
        kode_anggaran: [],
        kode_anggaranOri: [],
        peruntukan: [],
        peruntukanOri: [],
        sub_peruntukan: [],
        sub_peruntukanOri: [],
        treeExpandedKeys: [],
        anggaran: {
          tree: [],
          loadingtree: false,
        },
        listsetoranpajak: [],
        listsetoranpajakOri: [],
        listobjekpajak: [],
        fileList: [],
        dtl_value: "",
      },
      urlgetObjec_setran_pajak: "tax_transaction/objek_setoran_pajak",
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      paginationverificationdtl: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      verificationdtl_source: [],
      verificationdtl_sourceOri: [],
      data_verif_dtl: [],
      isvat: true,
      expand: {
        labelExpand: "Expand",
        leftcolumn: 0,
        rightcolumn: 24,
      },
    }
  },
  beforeCreate() {
    this.formDepositEntry = this.$form.createForm(this);
    this.formmodal = this.$form.createForm(this);
  },
  mounted() {
    Event.$on("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$on("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
    Event.$on("confirmMessageDelete", this.delete);
    this.$store.dispatch("Fetch_TYPE_TAX");

    this.pageLoading = true;
    this.asyncAxiosGet("main/cost_center", this.getAuth, {
      tlc: this.getAuth.username,
    })
      .then((res) => {
        this.modalData.costcenterOri = res.cost_center;
        this.modalData.costcenter = res.cost_center;
        this.modalData.kode_anggaranOri = res.kode_anggaran;
        this.modalData.jenis_anggaran = res.jenis_anggaran;
        this.modalData.peruntukanOri = res.peruntukan;
        this.modalData.peruntukan = res.peruntukan;
        //this.modalData.peruntukan = _.filter(res.peruntukan, (el) => el.anggaran_id == this.dataEdit.cost_center);
        this.modalData.sub_peruntukanOri = res.sub_peruntukan;
        this.modalData.sub_peruntukan = res.sub_peruntukan;
        this.pageLoading = false;
      })
  },
  beforeDestroy() {
    Event.$off("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$off("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
    Event.$off("confirmMessageDelete", this.delete);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getType_tax"
    ]),
    showbadge() {
      let result = false;
      if ((this.taxDt && this.taxDt.length > 0 && this.taxDt[0] != null && this.taxDt[1] != null) ||
        (this.typetransaction && this.typetransaction != 'all')) {
        result = true;
      }
      return result;
    },
    isAkuntansi() {
      return this.$route.name == "Spclaccount-pay-index" &&
        this.$route.path == "/akuntansiKeuangan/account_pay"
        ? true
        : false;
    },
    moreSearch: function () {
      let tempData = [];
      if (this.tabs.active == "verified") {
        tempData = this.verified_origin;
      } else if (this.tabs.active == "queue") {
        tempData = this.queue_origin;
      } else {
        tempData = this.needProcess_origin;
      }

      if (tempData.length > 0) {
        if (this.search && this.tabs.active == "verified") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_transaction &&
                obj.no_transaction
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_transaksi &&
                obj.no_transaksi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.catatan &&
                obj.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.nama_supplier &&
                obj.nama_supplier
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_bkk &&
                obj.no_bkk.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.due_date &&
                this.moment(obj.due_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.mata_uang, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_create &&
                obj.tlc_create
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        } else if (this.search && this.tabs.active == "queue") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_invoice &&
                obj.no_invoice
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.no_transaksi &&
                obj.no_transaksi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.catatan &&
                obj.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.nama_supplier &&
                obj.nama_supplier
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.due_date &&
                this.moment(obj.due_date)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency(obj.mata_uang, obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc_create &&
                obj.tlc_create
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        } else if (this.search && this.tabs.active == "needprocess") {
          tempData = tempData.filter(
            (obj) =>
              (obj.no_transaction &&
                obj.no_transaction.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0) ||
              (obj.description &&
                obj.description
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.jenis_transaksi_label &&
                obj.jenis_transaksi_label
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.value &&
                this.formatCurrency("IDR", obj.value)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.tlc &&
                obj.tlc
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (obj.create_dt &&
                this.moment(obj.create_dt)
                  .format(this.getDefaultDateFormat)
                  .toString()
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
          this.intoList(this.tabs.active, tempData);
        }

        if (this.typetransaction && this.typetransaction !== "all") {
          //console.log("this.typetransaction",this.typetransaction)
          tempData = tempData.filter(
            (obj) =>
              obj.jenis_transaksi &&
              obj.jenis_transaksi.toLowerCase() == this.typetransaction.toLowerCase()
          );
        }

        if (this.transactionDt && this.transactionDt.length > 0) {
          //console.log(this.transactionDt[0],this.transactionDt[1])
          let startDt = moment(this.transactionDt[0]).format("YYYY-MM-DD");
          let endDt = moment(this.transactionDt[1]).format("YYYY-MM-DD");
          tempData = tempData.filter(
            (obj) =>
              obj.trans_dt &&
              moment(obj.trans_dt).format("YYYY-MM-DD") >= startDt &&
              moment(obj.trans_dt).format("YYYY-MM-DD") <= endDt
          );
        }

        if (this.taxDt && this.taxDt.length > 0) {
          //console.log(this.transactionDt[0],this.transactionDt[1])
          let startDt = moment(this.taxDt[0]).format("YYYY-MM-DD");
          let endDt = moment(this.taxDt[1]).format("YYYY-MM-DD");
          tempData = tempData.filter(
            (obj) =>
              obj.create_dt &&
              moment(obj.create_dt).format("YYYY-MM-DD") >= startDt &&
              moment(obj.create_dt).format("YYYY-MM-DD") <= endDt
          );
        }

        if (this.stsDocument != "" && this.stsDocument != undefined) {
          if (this.stsDocument == "yes") {
            tempData = tempData.filter(
              (obj) =>
                obj.document_tax && obj.document_tax !== "No File Uploaded"
            );
          } else if (this.stsDocument == "no") {
            tempData = tempData.filter(
              (obj) =>
                obj.document_tax && obj.document_tax == "No File Uploaded"
            );
          }
        }

        if (this.tabs.active == "needprocess" && this.revisedStatus) {
          if (this.revisedStatus !== "all") {
            tempData = tempData.filter(
              (obj) => obj.button_aksi && obj.button_aksi == this.revisedStatus
            );
          }
        }
      }
      this.intoList(this.tabs.active, tempData);
      if (
        !this.tabs.active &&
        !this.search &&
        !this.transactionDt &&
        !this.taxDt &&
        !this.typetransaction
      ) {
        this.intoList(this.tabs.active, tempData);
      }
      return true;
    },
    listtax() {
      return _.filter(this.getType_tax, (el) => el.value !== "bea_masuk");
    },
    emptydataverified() {
      let result = false;
      if (this.verificationdtl_source.length > 0) {
        for (let w = 0; w < this.verificationdtl_source.length; w++) {
          if (this.verificationdtl_source[w].submited != "1") {
            result = true;
            break;
          }
        }
      } else {
        result = true;
      }
      return result;
    },
  },
  created() {
    this.handleReload();
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    filterOptiondtl(input, option) {
      return (
        option.componentOptions.children[0].children[0].children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetSearch() {
      this.search = undefined;
      this.transactionDt = undefined;
      this.taxDt[0] = this.moment().startOf('month');
      this.taxDt[1] = this.moment().endOf('month');
      this.typetransaction = "all";
      this.stsDocument = "all";
    },
    intoList(type, value) {
      if (type == "verified") {
        this.verified = value;
      } else if (type == "queue") {
        this.queue = value;
      } else {
        this.needProcess = value;
      }
    },
    handleReload() {
      this.pageLoading = true;
      this.asyncAxiosGet("tax_verification", this.getAuth, {
        tlc: this.getAuth.username,
      })
        .then((res) => {
          this.verified = res.transaction_verification;
          this.needProcess = res.need_process;
          this.queue = res.need_process;

          this.verified_origin = res.transaction_verification;
          this.needProcess_origin = res.need_process;
          this.queue_origin = res.need_process;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      this.resetSearch();
    },
    handleTab(val) {
      this.tabs.active = val;
      this.resetSearch();
      if (val === "needprocess") {
        this.listSuplier = this.needProcessSuplier;
        this.revisedStatus = "all";
      } else if (val === "queue") {
        this.listSuplier = this.quequeSuplier;
      } else if (val === "verified") {
        this.listSuplier = this.releaseSuplier;
      }
    },
    handleCreate(item) {
      this.$router.push({
        name: "list-create",
        params: { id: item.id, type: item.jenis_id },
      });
    },
    handleCreateAddendum(item) {
      this.$router.push({
        name: "createAddendum",
        params: { id: item.id, jenis_transaksi: item.jenis_transaksi },
      });
    },
    handleRelease(item) {
      this.$store
        .dispatch("releaseQueue", {
          auth: this.getAuth,
          id_ap: item.id_account_pay,
          id: item.id,
          jenis_transaksi: item.jenis_transaksi,
        })
        .then((res) => {
          this.$router.go();
          this.displayMessage("success-release");
        });
    },
    handleManifestRef(item) {
      const data = {
        rest_api:
          item.jenis_transaksi.toLowerCase() == "adendum"
            ? item.jenis_transaksi.toLowerCase()
            : "accountpay",
        id_manifest:
          item.jenis_transaksi.toLowerCase() == "adendum"
            ? item.id
            : item.id_account_pay,
        tlc: this.getAuth.username,
        user_pembuat: item.tlc_create,
      };

      this.handleView(data);
    },
    handleshowModalDeposit(item) {
      // if (item.type == "tax_manual") {
      this.loading.modalDepositKey = item.id_tax_transaction;
      this.loading.modalDeposit = true;
      this.asyncAxiosGet("tax_transaction/edit", this.getAuth, {
        id_transaction: item.id_transaction,
      })
        .then((response) => {
          this.dataEdit = response;
          this.dataEdit.treekode_anggaran = response.peruntukan + ";" + response.sub_peruntukan + ";" + response.kode_anggaran;

          this.asyncAxiosGet("main/cost_center", this.getAuth, {
            tlc: this.getAuth.username,
          })
            .then((res) => {
              this.modalData.costcenterOri = res.cost_center;
              this.modalData.costcenter = res.cost_center;
              this.modalData.kode_anggaranOri = res.kode_anggaran;
              this.modalData.jenis_anggaran = res.jenis_anggaran;
              this.modalData.peruntukanOri = res.peruntukan;
              this.modalData.peruntukan = _.filter(res.peruntukan, (el) => el.anggaran_id == this.dataEdit.cost_center);
              this.modalData.sub_peruntukanOri = res.sub_peruntukan;
              this.modalData.sub_peruntukan = res.sub_peruntukan;

              this.asyncAxiosGet("tax_transaction/tree_anggaran", this.getAuth, {
                anggaran_id: this.dataEdit.cost_center,
                peruntukan_id: this.dataEdit.peruntukan,
              })
                .then((res) => {
                  this.modalData.anggaran.tree = res.tree;
                  this.modalData.treeExpandedKeys = this.getParent(
                    this.modalData.anggaran.tree
                  );
                  this.modalData.anggaran.loadingtree = false;
                })
                .catch((err) => {
                  this.modalData.anggaran.loadingtree = false;
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error-other", responses.message);
                });

              this.asyncAxiosGet(
                this.urlgetObjec_setran_pajak,
                this.getAuth,
                { tlc: this.getAuth.username }
              )
                .then((res2) => {
                  // this.modalData.listsetoranpajak = res2.setoran;
                  this.modalData.listsetoranpajakOri = res2.setoran;
                  this.modalData.listobjekpajak = res2.objek;

                  this.loading.modalDepositKey = "";
                  this.loading.modalDeposit = false;

                  if (
                    this.dataEdit.file_document_tax &&
                    this.dataEdit.file_document_tax != "No File Uploaded"
                  ) {
                    let typefile = this.fileTypeFromUrl(
                      this.dataEdit.file_document_tax
                    );
                    let file = this.dataURLtoFile(
                      typefile + this.dataEdit.file_document,
                      this.dataEdit.file_document_tax
                    );
                    file.uid = "vc-upload-1-1";
                    file.status = "done";
                    file.url =
                      this.$serviceUrl + this.dataEdit.path_document_tax;
                    this.modalData.fileList = [];
                    this.modalData.fileList.push(file);
                  } else {
                    this.modalData.fileList = [];
                  }
                  this.modalProcess = !this.modalProcess;
                })
                .catch((err) => {
                  this.loading.modalDepositKey = "";
                  this.loading.modalDeposit = false;
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error-other", responses.message);
                });
            })
            .catch((err) => {
              this.loading.create = false;
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
        })
        .catch((err) => {
          this.loading.modalDepositKey = "";
          this.loading.modalDeposit = false;
          console.log(err);
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
      // } else {
      //   this.loading.modalDepositKey = item.id_tax_transaction;
      //   this.loading.modalDeposit = true;
      //   this.dataEdit = item;

      //   this.asyncAxiosGet(this.urlgetObjec_setran_pajak, this.getAuth, {
      //     tlc: this.getAuth.username,
      //   })
      //     .then((res) => {
      //       //this.dataEdit.listsetoranpajak = res.setoran;
      //       this.modalData.listsetoranpajakOri = res.setoran;
      //       this.dataEdit.listobjekpajak = res.objek;

      //       if (item.document_tax && item.document_tax != "No File Uploaded") {
      //         this.asyncAxiosGet("main/base_64", this.getAuth, {
      //           path: item.document_path,
      //         })
      //           .then((response) => {
      //             console.log(response);
      //             let typefile = this.fileTypeFromUrl(item.document_tax);
      //             let file = this.dataURLtoFile(
      //               typefile + response.file_document_tax,
      //               item.document_tax
      //             );
      //             file.uid = "vc-upload-1-1";
      //             file.status = "done";
      //             file.url = this.$serviceUrl + item.document_path;
      //             this.dataEdit.fileList = [];
      //             this.dataEdit.fileList.push(file);

      //             this.loading.modalDeposit = false;
      //             this.modalDepositEntry = !this.modalDepositEntry;
      //           })
      //           .catch((err) => {
      //             console.log(err);
      //             let responses = Object.assign({}, err.response.data);
      //             this.displayMessageValue("error-other", responses.message);
      //           });
      //       } else {
      //         this.loading.modalDeposit = false;
      //         this.modalDepositEntry = !this.modalDepositEntry;
      //       }
      //     })
      //     .catch((err) => {
      //       this.loading.modalDeposit = false;
      //       let responses = Object.assign({}, err.response.data);
      //       this.displayMessageValue("error-other", responses.message);
      //     });
      // }
    },
    handleManifest(item) {
      if (item.jenis_transaksi == "Adendum") {
        this.$router.push({
          name: "AddendumManifest",
          params: { id: item.id },
        });
      } else {
        if (this.isAkuntansi) {
          this.$router.push({
            name: "Spclaccount-pay-manifest",
            params: { id: item.id_account_pay },
          });
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: item.id_account_pay },
          });
        }
      }
    },
    handleManifestQueue(item) {
      if (item.jenis_transaksi == "Adendum") {
        this.$router.push({
          name: "AddendumManifest",
          params: { id: item.id },
        });
      } else {
        if (this.isAkuntansi) {
          this.$router.push({
            name: "Spclaccount-pay-manifest",
            params: { id: item.id_account_pay },
          });
        } else {
          this.$router.push({
            name: "account-pay-manifest",
            params: { id: item.id_account_pay },
          });
        }
      }
    },
    handleDocument(item) {
      this.$store
        .dispatch("getBuktiAP", { auth: this.getAuth, id: item.id })
        .then((res) => {
          this.buktiTransfer = res.data.data;
          this.modalDepositEntry = true;
        });
    },
    handleDownload(item) {
      window.open(this.$serviceUrl + item.url, "_blank");
    },
    handleClose() {
      this.modalDepositEntry = false;
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },

    handleRevisiAndClose(item) {
      const that = this;
      let title = "";
      let messageSukses = "";
      title = "Are you sure to revise this data";
      messageSukses = "Successfully revise data";

      this.$confirm({
        title: title,
        content: "Batal / OK?",
        onOk() {
          let promise = new Promise((resolve, reject) => {
            let data = {
              tlc: that.getAuth.username,
              aksi: item.button_aksi,
              id: item.id,
              jenis_transaksi: item.jenis_transaksi,
            };

            // try {
            //   resolve(data);
            // } catch {
            //   reject("error data");
            // }

            axios({
              method: "post",
              url: that.$serviceUrl + "account_pay/aksi_account_pay",
              data: data,
              auth: {
                username: that.getAuth.username,
                password: that.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": that.getAuth.apikey,
              },
            })
              .then(({ data, status }) => {
                resolve(data);
              })
              .catch((err) => {
                reject(err);
              });
          }).catch(() => console.log("Oops errors!"));
          promise
            .then((value) => {
              that.displayMessageValue("success-other", messageSukses);
              that.handleReload();
            })
            .then((err) => {
              if (err) {
                let responses = Object.assign({}, err.response.data);
                that.displayMessageValue("error-other", responses.message);
              }
            });
          return promise;
        },
        onCancel() { },
      });
    },

    handleviewAttacment(item) {
      window.open(this.$serviceUrl + item.document_path);
    },
    handledatachecked() { },
    taxDepositEntryCancel() {
      this.dataEdit = [];
      this.modalDepositEntry = !this.modalDepositEntry;
    },
    handleShowModalProcess(data, jenis) {
      //this.dataEdit = [];
      // this.modalData.anggaran.tree = [];
      // this.modalData.costcenterOri = [];
      // this.modalData.costcenter = [];
      // this.modalData.kode_anggaranOri = [];
      // this.modalData.jenis_anggaran = [];
      // this.modalData.peruntukanOri = [];
      // this.modalData.peruntukan = [];
      // this.modalData.sub_peruntukanOri = [];
      // this.modalData.sub_peruntukan = [];
      this.modalData.id_tax_verif_trans = (data.id ? data.id : "");
      this.modalData.jenis_transaksi = data.jenis_transaksi;
      this.modalData.jenis_transaksi_label = data.jenis_transaksi_label;
      this.modalData.no_transaction = data.no_transaction;
      this.modalData.fileList = [];
      this.loading.modalProcessKey = data.id_transaksi;
      this.loading.modalProcess = true;
      this.loading.loadJenis = jenis == "new" ? "edit" : jenis;
      if (this.loading.loadJenis == "view") {
        this.expand.leftcolumn = 0;
        this.expand.rightcolumn = 24;
      } else {
        this.expand.leftcolumn = 0;
        this.expand.rightcolumn = 24;
      }

      this.loading.create = true;
      this.asyncAxiosGet("tax_verification", this.getAuth, {
        id_transaksi: data.id_transaksi,
        jenis_transaksi: data.jenis_transaksi,
        transaksi: jenis == "new" ? "new" : "edit"
      })
        .then((res) => {
          //     this.modalData.costcenterOri = res.cost_center;
          this.modalData.id_header = res.id_header;
          this.modalData.detil_transaction = res.detil_transaction;
          for (let w = 0; w < this.modalData.detil_transaction.length; w++) {
            this.modalData.detil_transaction[w].disabled = false;
          }
          //this.modalData.listsetoranpajak = res.setoran;
          this.modalData.listsetoranpajakOri = res.setoran;
          this.modalData.listobjekpajak = res.objek;
          if (res.list_tax_dtl) {
            this.verificationdtl_source = res.list_tax_dtl;
            for (let x = 0; x < this.verificationdtl_source.length; x++) {
              if (this.verificationdtl_source[x].id == undefined)
                this.verificationdtl_source[x].id = this.verificationdtl_source[x].id_dtl;
            }
            this.verificationdtl_sourceOri = this.verificationdtl_source
          }
          this.dtlmodalchange();

          this.loading.create = false;
          this.modalProcess = !this.modalProcess;
          this.loading.modalProcess = false;

          if (jenis == "new") {
            this.handleReload();
          }
        })
        .catch((err) => {
          this.loading.create = false;
          this.loading.modalProcess = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    handleModalProcess() {
      this.modalProcess = !this.modalProcess;
    },
    handleModalClose() {
      this.data_verif_dtl = [];
      this.modalProcess = !this.modalProcess;
    },
    handleJenisAnggaran(e) {
      this.formmodal.setFieldsValue({
        cost_center: null,
        peruntukan: null,
        sub_peruntukan: null,
        kode_anggaran: null,
      });
      const filter = this.modalData.costcenterOri.filter(
        (obj) => obj.jns_anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      this.modalData.costcenter = filter;
      this.modalData.peruntukan = [];
      // this.anggaran.tree = [];
      // this.anggaran.treeModal = [];
      this.modalData.subPeruntukan = [];
    },
    handleCost(e) {
      this.$nextTick(function () {
        this.formmodal.setFieldsValue({
          peruntukan: null,
          sub_peruntukan: null,
          kode_anggaran: null,
        });
      });
      this.modalData.subPeruntukan = [];
      // this.modalData.anggaran.tree = [];
      // this.modalData.anggaran.treeModal = [];
      const peruntukan = this.modalData.peruntukanOri.filter(
        (obj) => obj.anggaran_id.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );
      this.modalData.peruntukan = peruntukan;
      // this.modalData.anggaran.anggaran_id = e;
      // this.modalData.data.cost_center_id = e;
    },
    handle_DetilTransaction(e) {
      let is_vat = this.formmodal.getFieldValue("is_vat");
      let params = _.filter(this.modalData.detil_transaction, (item) => item.id_dtl == e);
      this.modalData.dtl_value = this.formatCurrency('IDR', params[0].kredit);
      this.modalData.potensial_tax = params[0].potensial_tax ? params[0].potensial_tax : "0";
      this.modalData.reason_potensial = params[0].reason_potensial;
      this.handle_DetilTransaction2(e, is_vat);
    },
    handle_DetilTransaction2(e, isvat) {
      if (isvat == "0") {
        this.modalData.anggaran.loadingtree = true;
        let params = _.filter(this.modalData.detil_transaction, (item) => item.id_dtl == e);
        if (this.modalData.id_tax_verif_trans) { //if edit mode
          let existparam = _.filter(this.verificationdtl_source, (item) => item.id_dtl == e);
          params[0].anggaran_id = existparam[0].cost_center
          params[0].peruntukan_id = existparam[0].peruntukan
          this.modalData.peruntukan = _.filter(this.modalData.peruntukanOri, (el) => el.anggaran_id == params[0].anggaran_id);
        }
        this.$nextTick(function () {
          this.formmodal.setFieldsValue({
            cost_center: params[0].anggaran_id,
            peruntukan: params[0].peruntukan_id,
          });
        });

        this.asyncAxiosGet("tax_verification/tree_anggaran", this.getAuth, {
          anggaran_id: params[0].anggaran_id,
          peruntukan_id: params[0].peruntukan_id,
        })
          .then((res) => {
            this.modalData.anggaran.tree = res.tree;
            this.modalData.treeExpandedKeys = this.getParent(
              this.modalData.anggaran.tree
            );
            this.modalData.anggaran.loadingtree = false;
          })
          .catch((err) => {
            this.modalData.anggaran.loadingtree = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      }
    },
    getParent(root) {
      let data = [];
      root.forEach((item) => {
        if (item.key) {
          data.push(item.key);
        }

        if (item.children.length > 0) {
          item.children.forEach((d) => {
            data.push(d.key);
          });
        }
      });
      return data;
    },
    handlechoiceCost(item) {
    },
    filterTreeNode(input, option) {
      //console.log(input, option)
      return (
        option.data.props.texttitle == undefined ||
        (option.data.props.texttitle ? option.data.props.texttitle : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0 ||
        (option.data.props.kode_anggaran ? option.data.props.kode_anggaran : "")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeTaxType(e) {
      this.modalData.reftax_type = e;
      this.$nextTick(function () {
        this.formmodal.setFieldsValue({
          kode_setoran_pajak: null,
        });
      });
      this.filtertaxDeposit(e);
    },
    filtertaxDeposit(val) {
      this.modalData.listsetoranpajak = _.filter(this.modalData.listsetoranpajakOri, (item) => item.id_type_tax == val);
    },
    preventEnterButton() {
      //antisipasi tekan enter karena bisa mengkacaukan validator minus dikomponennya
      this.$nextTick(function () {
        this.$refs.addMainBtn.$children[0].$el.focus();
      });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    beforeUploadAttachment(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.modalData.fileList = [];
        this.modalData.fileList.push(file);
        return false;
      }
    },
    handleRemoveAttachment() {
      this.modalData.fileList = [];
    },
    handleAddVarification() {
      this.formmodal.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }
        this.loading.addVarification = true;

        let dtlnm = _.filter(this.modalData.detil_transaction, (item) => item.id_dtl == values.id_dtl);
        let newCode = values.kode_anggaran ? values.kode_anggaran.split(";") : [];
        let item_anggaran = "";
        let inputan = {
          tax_type: values.tax_type,
          tax_deposit: values.kode_setoran_pajak ? values.kode_setoran_pajak : "",
          kode_setoran_pajak: values.kode_setoran_pajak ? values.kode_setoran_pajak : "",
          tax_object: values.objek_pajak ? values.objek_pajak : "",
          objek_pajak: values.objek_pajak ? values.objek_pajak : "",
          dpp_value: values.dpp_value,
          tax_value: values.tax_value,
          jenis_transaksi: this.modalData.jenis_transaksi,
          id_header: this.modalData.id_header,
          id_dtl: values.id_dtl,
          detail: dtlnm[0].detail,
          kode_anggaran: newCode.length > 1 ? values.kode_anggaran : "",
          id_anggaran: newCode.length > 1 ? values.kode_anggaran : "",
          kode_anggaranSplit: newCode.length > 1 ? newCode[newCode.length - 1] : "",
          item_anggaran: item_anggaran,
          description: dtlnm[0].detail,
          is_vat: values.is_vat ? values.is_vat : "",
          transaction_dt: dtlnm[0].tanggal,
          cost_center: values.cost_center ? values.cost_center : "",
          peruntukan: values.peruntukan ? values.peruntukan : "",
          tgl: dtlnm[0].tanggal,
          harga: dtlnm[0].kredit,
        };

        if (this.modalData.fileList.length > 0) {
          inputan.file_document_tax = [];
          inputan.file_document_tax.push(this.modalData.fileList[0]);

          let xd = this.modalData.fileList[0];
          inputan.tax_document_name = xd.name;
        }

        let data = new FormData();
        if (this.dataEdit && this.dataEdit.id_transaction)
          data.append("id_transaction", this.dataEdit.id_transaction);
        data.append("tlc", this.getAuth.username);
        data.append(
          "date_of_tax",
          moment(values.tax_date).format("YYYY-MM-DD")
        );
        data.append("tax_type", inputan.tax_type);
        data.append("tax_deposit", inputan.tax_deposit);
        data.append("tax_object", inputan.tax_object);
        data.append("dpp_value", inputan.dpp_value);
        data.append("tax_value", inputan.tax_value);
        data.append("jenis_transaksi", inputan.jenis_transaksi);
        data.append("id_header", inputan.id_header);
        data.append("id_dtl", inputan.id_dtl);
        data.append("kode_anggaran", inputan.kode_anggaranSplit);
        data.append("is_vat", inputan.is_vat);
        data.append("description", inputan.description);
        data.append("transaction_dt", moment(inputan.transaction_dt).format("YYYY-MM-DD"));
        if (this.modalData.fileList.length > 0)
          data.append("file_document_tax", this.modalData.fileList[0]);

        let url = "";
        if (this.modalData.submited == "1") {
          url = "Tax_verification/edit";
          data.append("id_tax_verif_trans", this.modalData.id_tax_verif_trans);
        } else {
          url = "Tax_verification";
        }
        this.asyncAxiosPost(url, "formdata", this.getAuth, data)
          .then((response) => {
            this.loading.addVarification = false;
            //this.modalProcess = !this.modalProcess;
            let isPresent = _.filter(this.verificationdtl_source, (el) => el.tax_deposit != null);
            if (isPresent.length == 0) {
              this.handleReload();
            }

            if (this.modalData.submited == "0") {
              inputan.id = response.id;
              inputan.submited = response.submited;
              inputan.tax_document_path = response.tax_document_path;
              inputan.item_anggaran = response.item_anggaran;
              inputan.kode_anggaran = response.kode_anggaran;
              inputan.no_trans = response.kode_transaksi;
              this.verificationdtl_source.push(inputan);
              this.data_verif_dtl = _.filter(this.verificationdtl_source, (el) => el.id_dtl == inputan.id_dtl);
              this.displayMessage("success-save");
            } else {
              this.verificationdtl_source = _.filter(this.verificationdtl_source, (el) => el.id != this.modalData.id_tax_verif_trans);
              this.verificationdtl_sourceOri = this.verificationdtl_source
              inputan.id = response.id;
              inputan.submited = response.submited;
              inputan.item_anggaran = response.item_anggaran;
              inputan.kode_anggaran = response.kode_anggaran;
              inputan.tax_document_path = response.tax_document_path;
              inputan.no_trans = response.kode_transaksi;
              this.verificationdtl_source.push(inputan);
              this.data_verif_dtl = _.filter(this.verificationdtl_source, (el) => el.id_dtl == inputan.id_dtl);
              this.displayMessage("success-edit");
            }
            this.dtlmodalchange();
            //this.handleReload();
            this.isvat = true;
            this.modalData.is_vat = "1";
            this.formmodal.resetFields();
            this.formmodal.setFieldsValue({
              id_dtl: inputan.id_dtl,
              is_vat: inputan.is_vat,
            });
            this.modalData.anggaran.tree = null;
            this.modalData.fileList = [];
            //this.modalData.potensial_tax = null;
            //this.modalData.reason_potensial = "";
            this.modalData.id_tax_verif_trans = '';
            this.modalData.submited = "0";

            //hidden halaman entry
            //this.expand.leftcolumn = 0;
            //this.expand.rightcolumn = 24;
            //this.expand.labelExpand = "Expand";
          })
          .catch((err) => {
            console.log(err);
            this.modalProcess = !this.modalProcess;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
            this.loading.addVarification = false;
          });
      });
    },
    handleCancelVarification() {
      this.modalData.id_tax_verif_trans = "";
      // this.modalData.potensial_tax = null;
      // this.modalData.reason_potensial = null;
      this.modalData.anggaran.tree = null;
      this.modalData.submited = "0";
      this.modalData.is_vat = "1";
      this.$nextTick(function () {
        this.formmodal.setFieldsValue({
          //id_dtl: null,
          tax_type: null,
          kode_setoran_pajak: null,
          objek_pajak: null,
          dpp_value: null,
          tax_value: null,
          // file_document_tax: null,
          // kode_anggaran: null,
          // cost_center: null,
          // peruntukan: null
        });
      });
      this.modalData.fileList = [];
      // this.expand.leftcolumn = 0;
      // this.expand.rightcolumn = 24;
      // this.expand.labelExpand = "Expand";
    },
    returntoList() {
      this.data_verif_dtl = [];
      this.modalData.id_tax_verif_trans = "";
      this.expand.leftcolumn = 0;
      this.expand.rightcolumn = 24;
      this.expand.labelExpand = "Expand";
    },
    taxDepositEntryUpdate() {
      this.handleReload();
    },
    handleDeleteModalDeposit(item) {
      this.confirmMessageValue("confirm-delete", item);
    },
    deletedtl(id) {
      if (this.data_verif_dtl.length == 1) {
        this.displayMessageValue("error-other", "Can't be deleted, because at least 1 data existing!");
      } else {
        const that = this;
        this.$confirm({
          title: "Are you sure to delete this data?",
          content: "",
          okText: "Yes",
          cancelText: "No",
          onOk() {
            that.loading.deleteVarification = true;
            that.loading.modalProcessKey = id;

            that.asyncAxiosDelete(
              "Tax_verification",
              "application/json",
              that.getAuth,
              { id: id }
            )
              .then(() => {
                that.loading.deleteVarification = false;
                that.loading.modalProcessKey = "";
                let datatodel = _.filter(that.verificationdtl_source, (el) => el.id == id);
                that.verificationdtl_source = _.filter(that.verificationdtl_source, (el) => el.id != id);
                that.verificationdtl_sourceOri = that.verificationdtl_source

                let index = _.findIndex(that.modalData.detil_transaction, (item) => item.id_dtl == datatodel[0].id_dtl);
                if (index >= 0) {
                  that.modalData.detil_transaction[index].disabled = false;
                }

                that.data_verif_dtl = _.filter(that.verificationdtl_source, (el) => el.id_dtl == datatodel[0].id_dtl);
                that.displayMessage("success-del");
                if (that.verificationdtl_source.length == 0)
                  that.handleReload();
              })
              .catch((err) => {
                console.log(err);
                // this.loading.deleteVarification = false;
                // this.loading.modalProcessKey = "";
                // let responses = Object.assign({}, err.response.data);
                // this.displayMessageValue("error-other", responses.message);
              });
          },
          onCancel() { },
        })
      }
    },
    handlelinkNo(item) {
      item.id_manifest = item.id_transaksi;
      item.user_pembuat = item.tlc;
      if(item.rest_api=="") item.rest_api=item.jenis_transaksi
      this.handleView(item, true);
    },
    gettitletax(val) {
      let res = _.filter(this.getType_tax, (el) => el.value == val);
      return res.length > 0 ? res[0].text : "-";
    },
    viewFiledtl(tax_document_name, tax_document_path) {
      if (tax_document_path != '') {
        const url = this.$serviceUrl + tax_document_path;
        window.open(url, "_blank");
      }
    },
    editdtl(id) {
      this.loading.spinform = true;
      let res = _.filter(this.verificationdtl_source, (el) => el.id == id);
      this.asyncAxiosGet("Tax_verification/edit", this.getAuth, {
        id_dtl: res[0].id_dtl,
      }).then((result) => {
        this.modalData.id_tax_verif_trans = id;
        this.data_verif_dtl = result.list_tax_dtl;
        let params = _.filter(this.modalData.detil_transaction, (item) => item.id_dtl == res[0].id_dtl);
        this.modalData.dtl_value = this.formatCurrency('IDR', params[0].kredit);

        let setdata = new Promise((resolve, reject) => {
          this.handle_DetilTransaction(res[0].id_dtl);
          resolve(); // when successful
          reject();  // when error
        });
        setdata.then(() => {
          this.formmodal.setFieldsValue({
            kode_anggaran: (res[0].is_vat ? res[0].id_anggaran : null)
          });
        });
        this.dtlmodalchange();
        this.filtertaxDeposit(res[0].tax_type);
        this.$nextTick(function () {
          this.formmodal.setFieldsValue({
            id_dtl: res[0].id_dtl,
            reason_potensial: null,
            tax_type: res[0].tax_type,
            kode_setoran_pajak: res[0].kode_setoran_pajak,
            objek_pajak: res[0].objek_pajak,
            dpp_value: res[0].dpp_value,
            tax_value: res[0].tax_value,
            file_document_tax: null,
            is_vat: (res[0].is_vat ? res[0].is_vat : "1"),
          });
        });
        this.modalData.submited = res[0].submited;
        this.modalData.reftax_type = res[0].tax_type;
        if (res[0].is_vat == "0") {
          // let val = {
          //   target: {
          //     value: res[0].is_vat.toString()
          //   }
          // };
          // this.handleChangeVat(val)
          this.isvat = false;
          this.handle_DetilTransaction2(res[0].id_dtl, res[0].is_vat);
        }
        if (res[0].tax_document_name && res[0].tax_document_name != '') {
          this.loading.spinform = true;
          this.asyncAxiosGet("main/base_64", this.getAuth, {
            path: res[0].tax_document_path,
          })
            .then((response) => {
              let typefile = this.fileTypeFromUrl(res[0].tax_document_name);
              let file = this.dataURLtoFile(
                typefile + response.file_document_tax,
                res[0].tax_document_name
              );
              file.uid = "vc-upload-1-1";
              file.status = "done";
              file.url = this.$serviceUrl + res[0].tax_document_path;
              this.modalData.fileList = [];
              this.modalData.fileList.push(file);
              this.loading.spinform = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading.spinform = false;
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
        } else {
          this.loading.spinform = false;
        }
        //untuk display menampilkan entry
        this.expand.leftcolumn = 24;
        this.expand.rightcolumn = 0;
        this.expand.labelExpand = "Collapse";
      })
        .catch((err) => {
          this.modalData.anggaran.loadingtree = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    dtlmodalchange() {
      for (let i = 0; i < this.verificationdtl_source.length; i++) {
        let index = _.findIndex(this.modalData.detil_transaction, (item) => item.id_dtl == this.verificationdtl_source[i].id_dtl);
        if (index >= 0) {
          this.modalData.detil_transaction[index].disabled = true;
        }
      }
    },
    submitverified() {
      const that = this;
      this.$confirm({
        title: "Are you sure to set verified transaction?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          let params = new FormData();
          params.append("jenis_transaksi", that.modalData.jenis_transaksi);
          params.append("id_header", that.modalData.id_header);
          that.loading.submitVarification = true;
          that.asyncAxiosPost("Tax_verification/submit", "formdata", that.getAuth, params)
            .then((res) => {
              if (res.status == true) {
                that.displayMessageValue("success-other", res.message);
                that.handleCancelVarification();
                that.handleReload();
              } else {
                that.displayMessageValue(
                  "error-other",
                  res.message
                );
              }
              that.loading.submitVarification = false;
              that.modalProcess = false;
            })
            .catch(err => {
              console.log(err);
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
              that.loading.submitVarification = false;
            });
        },
        onCancel() { },
      });
    },
    handleChangeVat(val) {
      if (val.target.value == "1") {
        this.isvat = true;
        this.$nextTick(function () {
          this.formmodal.setFieldsValue({
            kode_anggaran: null,
          });
        });
      } else if (val.target.value == "0") {
        this.isvat = false;
        let id_dtl = this.formmodal.getFieldValue("id_dtl");
        if (id_dtl == undefined) {
          return
        }
        let params = _.filter(this.modalData.detil_transaction, (item) => item.id_dtl == id_dtl);
        this.modalData.peruntukan = _.filter(this.modalData.peruntukanOri, (el) => el.anggaran_id == params[0].anggaran_id);

        let setdata = new Promise((resolve, reject) => {
          this.handle_DetilTransaction2(id_dtl, val.target.value);
          resolve(); // when successful
          reject();  // when error
        });

        setdata.then(async () => {
          let res = _.filter(this.verificationdtl_source, (el) => el.id == this.modalData.id_tax_verif_trans);
          await this.formmodal.setFieldsValue({
            kode_anggaran: res[0].id_anggaran
          });
        });

      }
    },
    handleExpand() {
      if (this.expand.leftcolumn == 24 && this.expand.rightcolumn == 0) {
        this.expand.leftcolumn = 0;
        this.expand.rightcolumn = 24;
        this.expand.labelExpand = "Collapse";
      } else {
        this.expand.leftcolumn = 24;
        this.expand.rightcolumn = 0;
        this.expand.labelExpand = "Expand";
      }
    },
    handle_Peruntukan(e) {
      let anggId = this.formmodal.getFieldValue("cost_center")
      if (anggId) {
        this.modalData.anggaran.loadingtree = true
        this.$nextTick(function () {
          this.formmodal.setFieldsValue({
            kode_anggaran: null,
          });
        });
        this.asyncAxiosGet("tax_verification/tree_anggaran", this.getAuth, {
          anggaran_id: anggId,
          peruntukan_id: e,
        })
          .then((res) => {
            this.modalData.anggaran.tree = res.tree;
            this.modalData.treeExpandedKeys = this.getParent(
              this.modalData.anggaran.tree
            );
            this.modalData.anggaran.loadingtree = false;
          })
          .catch((err) => {
            this.modalData.anggaran.loadingtree = false;
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      } else {
        this.displayMessageValue("error-other", "Cost Center Must be selected first!");
      }
    },
    searchingListDtl(val) {
      val = val.target.value
      this.verificationdtl_source = _.filter(this.verificationdtl_sourceOri, (item) =>
        moment(item.tgl, this.getStandartFormatDate).format(this.getDefaultDateFormat).toLowerCase().indexOf(val.toLowerCase()) >= 0 ||
        (item.item_anggaran && item.item_anggaran.toLowerCase().indexOf(val.toLowerCase()) >= 0) ||
        (item.detail && item.detail.toLowerCase().indexOf(val.toLowerCase()) >= 0) ||
        (item.kode_anggaran && item.kode_anggaran.toLowerCase().indexOf(val.toLowerCase()) >= 0) ||
        (item.no_trans && item.no_trans.toLowerCase().indexOf(val.toLowerCase()) >= 0))
    }
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);

  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border-bottom: 1px dashed darken(white, 10);
    padding: @padding;
  }

  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.ant-select-dropdown-menu {
  width: 500px;
  overflow: visible;
  display: block;
}

.ant-select-dropdown--single {
  width: 500px;
  overflow: visible !important;
  display: block !important
}
</style>

<style lang="less">
.custom-tabs {
  .ant {
    &-tabs-bar {
      margin-bottom: 0;
    }

    &-tabs-content {
      flex: 1;
    }
  }
}

.ant-table-thead>tr>th {
  text-align: center;
}

.lblTransactionType,
.lbltaxable {
  border-top: solid 1px black;
  text-align: right;
  color: darken(@color-primary, 5) !important;
  font-size: x-small;
}

.lblnottaxable {
  border-top: solid 1px black;
  text-align: right;
  font-size: x-small;
}

.ant-select-dropdown--single {
  width: 500px !important;
}

.selectedRow {
  background-color: aliceblue !important;
}
</style>
